import { render, staticRenderFns } from "./MappageDeTypesDeDocuments.vue?vue&type=template&id=3df274cf&"
import script from "./MappageDeTypesDeDocuments.vue?vue&type=script&lang=js&"
export * from "./MappageDeTypesDeDocuments.vue?vue&type=script&lang=js&"
import style0 from "./MappageDeTypesDeDocuments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports